import _includes from 'lodash.includes';

export function includes(collection: any, value: number | string) {
  return _includes(collection, value);
}
